import { observer } from 'mobx-react';
import { Drawer, Empty } from 'antd';
import { useStore } from '@/stores';
import { helpTopics } from './topics';

// Root-level drawer that renders the help topic currently open in HelpStore.
// Mounted once at the AppShell so any HelpHotspot anywhere can open it.

export const HelpDrawer = observer(function HelpDrawer() {
  const { helpStore } = useStore();
  const topic = helpStore.openTopic ? helpTopics[helpStore.openTopic] : null;

  return (
    <Drawer
      open={helpStore.openTopic != null}
      onClose={() => helpStore.close()}
      width={580}
      destroyOnClose
      title={topic ? topic.label : 'Help'}
    >
      {topic ? (
        <topic.Body />
      ) : (
        <Empty description="No content available for this topic." />
      )}
    </Drawer>
  );
});
